import {
  COUNTRIES,
  CURRENCIES,
  MARKETPLACES,
  MARKET_STATUS,
  TRUSTMARKS,
} from '@config/constants'
import { dangerouslyGetRuntimeConfig } from '@config/variables'
import { IS_DEVELOPMENT } from '@config/variables/helpers'
import { ROUTES } from '@router'

const { FF_NEW_URL_FORMAT } = dangerouslyGetRuntimeConfig()
const useNewUrl = (country) => FF_NEW_URL_FORMAT.includes(country)
// TODO: [FOTA-12] Market's configuration, including this VD landing `uuid`, will be part of a dedicated endpoint.
// Until then, we can retrieve it using https://preprod.backmarket.fr/bm/landing_page?includes=hero&slug=vanishing-deals-reconditionne.html
const vanishingDealsLandingId = IS_DEVELOPMENT
  ? 'dbafc044-be4b-44f7-8216-7cd424c94a8d'
  : 'b4c30a3f-1b6e-4383-af8d-f9aab7ea135a'

const fromYoutube = ({ id, params = '' }) =>
  `https://www.youtube.com/embed/${id}?rel=0&amp;showinfo=0${params}`

const APP_CONFIG = {
  [COUNTRIES.FR]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.FR)
      ? `/l/vanishing-deals-reconditionne/${vanishingDealsLandingId}`
      : '/vanishing-deals-reconditionne.html',
    buyback: {
      enabled: true,
      swapAvailable: true,
      hasRib: true,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'fr-fr',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/fr-fr',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/presse.html',
    routesValidation: {
      product: '.*-pas-cher',
      productLanding: '.*-reconditionnee?s?.html',
      reviewsProductLanding: '.*-reconditionnee?s?',
      shop: 'boutique',
    },
    serviceFeeGuideRoute: {
      name: ROUTES.BUYING_GUIDE.SELF,
      params: {
        slug: 'pourquoi-back-market-facture-frais-de-service-qualite',
        category: 'news',
        id: 741,
      },
    },
    ewasteGuideRoute: {
      name: ROUTES.BUYING_GUIDE.SELF,
      params: {
        slug: 'impact-ewaste',
        category: 'news',
        id: 936,
      },
    },
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.TRUSTED_SHOPS,
    trustmarkConfig: {
      id: 'X194F6470570B4368A91A3C7230E9014C',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: true,
    vatIncluded: false,
    video404: fromYoutube({ id: 'V-_hrGnuBoM' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.AT]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.AT)
      ? `/l/vanishing-deals-gebraucht/${vanishingDealsLandingId}`
      : '/vanishing-deals-gebraucht.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'de-at',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/de-at',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/presse.html',
    routesValidation: {
      product: '.*-gebraucht',
      productLanding: '.*-gebraucht.html',
      reviewsProductLanding: '.*-gebraucht',
      shop: 'shop',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    trustmark: TRUSTMARKS.TRUSTED_SHOPS,
    trustmarkConfig: {
      id: 'XE714EB9CDE3DA7C8DD4DCFF5B0CE6B9E',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: true,
    vatIncluded: true,
    video404: fromYoutube({ id: 'viGnI3gZMqU' }),
    warranty: {
      duration: 36,
      displayInYear: false,
    },
  },
  [COUNTRIES.BE]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.BE)
      ? `/l/vanishing-deals-reconditionne/${vanishingDealsLandingId}`
      : '/vanishing-deals-reconditionne.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'fr-be',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/fr-be',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/presse.html',
    routesValidation: {
      product: '.*-pas-cher',
      productLanding: '.*-reconditionnee?s?.html',
      reviewsProductLanding: '.*-reconditionnee?s?',
      shop: 'boutique',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.TRUSTED_SHOPS,
    trustmarkConfig: {
      id: 'XB9BE628A37B8B2E1477584BD94039251',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: true,
    vatIncluded: false,
    video404: fromYoutube({ id: 'V-_hrGnuBoM' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.DE]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.DE)
      ? `/l/vanishing-deals-gebraucht/${vanishingDealsLandingId}`
      : '/vanishing-deals-gebraucht.html',
    buyback: {
      enabled: true,
      swapAvailable: true,
      hasRib: true,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'de-de',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/de',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/presse.html',
    routesValidation: {
      product: '.*-gebraucht',
      productLanding: '.*-gebraucht.html',
      reviewsProductLanding: '.*-gebraucht',
      shop: 'shop',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.TRUSTED_SHOPS,
    trustmarkConfig: {
      id: 'X0D2D87BCBFAE89812C9338C968A4BD77',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: true,
    vatIncluded: true,
    video404: fromYoutube({ id: 'haECT-SerHk' }),
    warranty: {
      duration: 24,
      displayInYear: false,
    },
  },
  [COUNTRIES.ES]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.ES)
      ? `/l/vanishing-deals-reacondicionado/${vanishingDealsLandingId}`
      : '/vanishing-deals-reacondicionado.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'es-es',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/es',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/prensa.html',
    routesValidation: {
      product: '.*-segunda-mano',
      productLanding: '.*-reacondicionado?a?s?.html',
      reviewsProductLanding: '.*-reacondicionado?a?s?',
      shop: 'tienda',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: true,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.CONFIANZA_ONLINE,
    trustmarkConfig: {
      id: 'X416F4F5FD9E8CB7EC326CBA57589BE5B',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: true,
    vatIncluded: true,
    video404: fromYoutube({ id: 'A8qezmx3r1s' }),
    warranty: {
      displayInYear: true,
      duration: 24,
    },
  },
  [COUNTRIES.FI]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.FI)
      ? `/l/vanishing-deals-kunnostettu/${vanishingDealsLandingId}`
      : '/vanishing-deals-kunnostettu.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'fi-fi',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/fi-fi',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    // TODO: create a dedicated page in pastrami. This is still a badoom view.
    press: '/press.html',
    routesValidation: {
      product: '.*-kaytetty',
      productLanding: '.*-kunnostettu.html',
      reviewsProductLanding: '.*-kunnostettu',
      shop: 'shop',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: false,
    trustmark: TRUSTMARKS.TRUSTPILOT,
    trustmarkConfig: {
      templateId: '53aa8807dec7e10d38f59f32',
      businessUnitId: '5eb28e4f90998f0001ecc108',
      href: 'https://fi.trustpilot.com/review/backmarket.fi',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: '0d_xT4GMYZo', params: '&start=332&end=374' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.GB]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.GB)
      ? `/l/refurbished-vanishing-deals/${vanishingDealsLandingId}`
      : '/refurbished-vanishing-deals.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    coolingOffDays: 30,
    cgvModalLegals: false,
    countryCode: 'en-gb',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.GBP,
    faqUrl: 'https://help.backmarket.com/hc/en-gb',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: 'https://press.backmarket.com/',
    routesValidation: {
      product: 'second-hand-.*',
      productLanding: 'refurbished-.*.html',
      reviewsProductLanding: 'refurbished-.*',
      shop: 'seller',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.TRUSTPILOT,
    trustmarkConfig: {
      businessUnitId: '5e2b02758b37ba0001e1d426',
      href: 'https://uk.trustpilot.com/review/backmarket.co.uk',
      templateId: '53aa8807dec7e10d38f59f32',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: 'Al7J6cSaSPw' }),
    warranty: {
      duration: 12,
      displayInYear: false,
    },
  },
  [COUNTRIES.GR]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.GR)
      ? `/l/refurbished-spartarista-flash-sales/${vanishingDealsLandingId}`
      : '/refurbished-spartarista-flash-sales.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'el-gr',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/el',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/press.html',
    routesValidation: {
      product: '.*-ftino-proion',
      productLanding: 'refurbished-.*.html',
      reviewsProductLanding: 'refurbished-.*',
      shop: 'seller',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: false,
    trustmark: TRUSTMARKS.TRUSTPILOT,
    trustmarkConfig: {
      businessUnitId: '60634b8d27f4190001f3896e',
      href: 'https://gr.trustpilot.com/review/backmarket.gr',
      templateId: '53aa8807dec7e10d38f59f32',
    },
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: 'qo4E0qGypAk' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.IE]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.IE)
      ? `/l/refurbished-good-deals/${vanishingDealsLandingId}`
      : '/refurbished-good-deals.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'en-ie',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/en-ie',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/press.html',
    routesValidation: {
      product: 'second-hand-.*',
      productLanding: 'refurbished-.*.html',
      reviewsProductLanding: 'refurbished-.*',
      shop: 'seller',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: true,
    showInsuranceCatchupModal: false,
    trustmark: TRUSTMARKS.TRUSTPILOT,
    trustmarkConfig: {
      templateId: '53aa8807dec7e10d38f59f32',
      businessUnitId: '60634b8927f4190001f3896b',
      href: 'https://ie.trustpilot.com/review/backmarket.ie',
    },
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: 'Al7J6cSaSPw' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.IT]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.IT)
      ? `/l/vanishing-deals-ricondizionato/${vanishingDealsLandingId}`
      : '/vanishing-deals-ricondizionato.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'it-it',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/it',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/stampa.html',
    routesValidation: {
      product: '.*-miglior-prezzo',
      productLanding: '.*-ricondizionat[oai]{1}.html',
      reviewsProductLanding: '.*-ricondizionat[oai]{1}',
      shop: 'shop',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.TRUSTPILOT,
    trustmarkConfig: {
      templateId: '53aa8807dec7e10d38f59f32',
      businessUnitId: '5c6301badc82bd00015430aa',
      href: 'https://it.trustpilot.com/review/backmarket.it',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: 'ETRshTcTndo' }),
    warranty: {
      duration: 12,
      displayInYear: false,
    },
  },
  [COUNTRIES.NL]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.NL)
      ? `/l/vanishing-deals-refurbished/${vanishingDealsLandingId}`
      : '/vanishing-deals-refurbished.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'nl-nl',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/nl',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/presse.html',
    routesValidation: {
      product: '.*-niet-duur',
      productLanding: '.*-refurbished.html',
      reviewsProductLanding: '.*-refurbished',
      shop: 'shop',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.TRUSTED_SHOPS,
    trustmarkConfig: {
      id: 'XD3D9E2C9264223766FEDD3DB22395FA0',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: true,
    vatIncluded: false,
    video404: fromYoutube({ id: '8gqpAEsC_xE' }),
    warranty: {
      duration: 36,
      displayInYear: false,
    },
  },
  [COUNTRIES.PT]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.PT)
      ? `/l/melhores-ofertas-recondicionadas/${vanishingDealsLandingId}`
      : '/melhores-ofertas-recondicionadas.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'pt-pt',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/pt',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    press: '/imprensa.html',
    routesValidation: {
      product: '.*-barato',
      productLanding: '.*-recondicionado?a?s?.html',
      reviewsProductLanding: '.*-recondicionado?a?s?',
      shop: 'loja',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: true,
    showInsuranceCatchupModal: false,
    trustmark: TRUSTMARKS.TRUSTPILOT,
    trustmarkConfig: {
      templateId: '53aa8807dec7e10d38f59f32',
      businessUnitId: '60377c9970c83a000172de3d',
      href: 'https://pt.trustpilot.com/review/backmarket.pt ',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: 'tHza_jWceDk' }),
    warranty: {
      displayInYear: true,
      duration: 24,
    },
  },
  [COUNTRIES.SE]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.SE)
      ? `/l/rekonditionerad-super-bra-erbjudanden/${vanishingDealsLandingId}`
      : '/rekonditionerad-super-bra-erbjudanden.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'sv-se',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.SEK,
    faqUrl: 'https://help.backmarket.com/hc/sv',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: false,
    press: '',
    routesValidation: {
      product: 'begagnad-.*',
      productLanding: 'rekonditionerad-.*.html',
      reviewsProductLanding: 'rekonditionerad-.*',
      shop: 'seller',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: true,
    showInsuranceCatchupModal: false,
    // TODO set to trustpilot when enough reviews
    trustmark: TRUSTMARKS.NONE,
    trustmarkConfig: {
      templateId: '53aa8807dec7e10d38f59f32',
      businessUnitId: '60634bad27f4190001f38973',
      href: 'https://fr.trustpilot.com/review/backmarket.se',
    },
    useTrustedShops: false,
    vatIncluded: true,
    video404: fromYoutube({ id: 'v8_7yPocGPg' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.SK]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.SK)
      ? `/l/repasovane-bleskovy-predaj/${vanishingDealsLandingId}`
      : '/repasovane-bleskovy-predaj.html',
    buyback: {
      enabled: false,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: true,
    coolingOffDays: 30,
    countryCode: 'sk-sk',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.EUR,
    faqUrl: 'https://help.backmarket.com/hc/sk',
    marketplace: MARKETPLACES.EU,
    mobileAppAvailable: true,
    // eslint-disable-next-line line-comment-position
    press: '', // TODO
    routesValidation: {
      product: 'lacne-.*',
      productLanding: 'repasovane-.*.html',
      reviewsProductLanding: 'repasovane-.*',
      shop: 'seller',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: false,
    showIncludedVat: true,
    showInsuranceCatchupModal: false,
    trustmark: TRUSTMARKS.NONE,
    trustmarkConfig: {
      templateId: '53aa8807dec7e10d38f59f32',
      businessUnitId: '60634bb1e143b400018548c0',
      href: 'https://fr.trustpilot.com/review/backmarket.sk',
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: false,
    vatIncluded: true,
    // eslint-disable-next-line line-comment-position
    video404: fromYoutube({ id: 'd73MEkygsiY' }),
    warranty: {
      displayInYear: false,
      duration: 12,
    },
  },
  [COUNTRIES.US]: {
    bestSalesLandingLink: useNewUrl(COUNTRIES.US)
      ? `/l/refurbished-vanishing-deals/${vanishingDealsLandingId}`
      : '/refurbished-vanishing-deals.html',
    buyback: {
      enabled: true,
      swapAvailable: false,
      hasRib: false,
    },
    cgvModalLegals: false,
    coolingOffDays: 30,
    countryCode: 'en-us',
    countryStatus: MARKET_STATUS.OPEN,
    currency: CURRENCIES.USD,
    faqUrl: 'https://help.backmarket.com/hc/en-us',
    marketplace: MARKETPLACES.NA,
    mobileAppAvailable: true,
    press: 'https://press.backmarket.com/',
    routesValidation: {
      product: 'tested-and-certified-used-.*',
      productLanding: 'refurbished-.*.html',
      reviewsProductLanding: 'refurbished-.*',
      shop: 'seller',
    },
    serviceFeeGuideRoute: {},
    ewasteGuideRoute: {},
    showCarrier: true,
    showIncludedVat: false,
    showInsuranceCatchupModal: true,
    trustmark: TRUSTMARKS.GOOGLE_REVIEWS,
    trustmarkConfig: {
      merchantId: 118622995,
    },
    // TODO [PI-1678] Improve trustmarks config when specs available
    useTrustedShops: false,
    vatIncluded: false,
    video404: fromYoutube({ id: 'Al7J6cSaSPw' }),
    warranty: {
      duration: 12,
      displayInYear: true,
    },
  },
}
export default APP_CONFIG
